import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';
import { authService } from '../services/supabase';
import '../styles/login.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);

    try {
      const { error } = await authService.requestPasswordReset(email);
      if (error) throw error;
      setSubmitted(true);
    } catch (err) {
      setError(err.message || 'Error al enviar el enlace de recuperacion.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <Container>
        <Row className="justify-content-center align-items-center min-vh-100">
          <Col xs={12} sm={10} md={8} lg={6} xl={5}>
            <Card className="shadow-lg login-card">
              <Card.Body className="p-4 p-sm-5">
                <div className="text-center mb-4">
                  <img
                    src={`${process.env.PUBLIC_URL}/images/logos/Logo_PROMEDIC-07.png`}
                    alt="ProMedic Logo"
                    className="login-logo mb-3"
                  />
                  <h2 className="fw-bold text-primary">Recuperar Contraseña</h2>
                  <p className="text-muted">
                    Ingresa tu email y te enviaremos un enlace para restablecer tu contraseña.
                  </p>
                </div>

                {submitted ? (
                  <Alert variant="success">
                    <i className="bi bi-check-circle me-2"></i>
                    Si el email está registrado, recibirás un enlace para restablecer tu contraseña. Revisa tu bandeja de entrada y spam.
                  </Alert>
                ) : (
                  <>
                    {error && (
                      <Alert variant="danger" dismissible onClose={() => setError(null)}>
                        {error}
                      </Alert>
                    )}

                    <Form onSubmit={handleSubmit}>
                      <Form.Group className="mb-3" controlId="email">
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="usuario@example.com"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                          autoComplete="email"
                          disabled={loading}
                          autoFocus
                        />
                      </Form.Group>

                      <Button
                        variant="primary"
                        type="submit"
                        className="w-100 py-2 mb-3"
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Enviando...
                          </>
                        ) : (
                          'Enviar enlace de recuperacion'
                        )}
                      </Button>
                    </Form>
                  </>
                )}

                <div className="text-center mt-3">
                  <Link to="/login" className="text-muted small">
                    <i className="bi bi-arrow-left me-1"></i>
                    Volver al inicio de sesión
                  </Link>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ForgotPassword;
